<template>
  <div class="home-page">
    <section class="gps-hero" id="top">
      <div
        v-for="(slide, index) in heroSlides"
        :key="slide.title"
        class="hero-slide"
        :class="{ active: index === activeHeroIndex }"
      >
        <img :src="slide.image" :alt="slide.title">
      </div>
      <div class="hero-backdrop"></div>
      <div class="container hero-stack">
        <div class="hero-copy">
          <p class="hero-kicker">{{ activeHero.kicker }}</p>
          <h1>{{ activeHero.title }}</h1>
          <p class="hero-subtitle">{{ activeHero.subtitle }}</p>
          <router-link class="btn primary" :to="activeHero.detailPath">查看详情</router-link>
        </div>

        <div class="hero-controls" aria-label="首页banner切换">
          <button class="hero-arrow" type="button" aria-label="上一张banner" @click="prevHero">
            <img :src="heroArrowLeft" alt="">
          </button>
          <div class="hero-tabs" role="tablist" aria-label="首页banner轮播">
            <button
              v-for="(slide, index) in heroSlides"
              :key="slide.title"
              type="button"
              role="tab"
              :aria-selected="index === activeHeroIndex ? 'true' : 'false'"
              :class="{ active: index === activeHeroIndex }"
              @click="goToHero(index)"
            >
              <span>{{ slide.tab }}</span>
              <i v-if="index === activeHeroIndex" :key="heroProgressKey"></i>
            </button>
          </div>
          <button class="hero-arrow" type="button" aria-label="下一张banner" @click="nextHero">
            <img :src="heroArrowRight" alt="">
          </button>
        </div>
      </div>
    </section>

    <router-link tag="section" class="about-band" id="about" to="/about">
      <div class="container about-layout">
        <div class="about-copy">
          <h2>关于千讯云创</h2>
          <p class="section-overline">About Qianxun Yunchuang</p>
          <p>
            深圳市千讯云创科技有限公司以下简称“千讯云创”，是一家以GPS/北斗位置服务为核心的物联网高科技企业，专业从事GPS/北斗位置服务平台开发、GPS/北斗定位终端研发、生产、销售，提供一站式位置服务解决方案。
          </p>
          <span class="blue-tag">科技引领未来 定位创造价值</span>
        </div>
      </div>
      <div class="about-service-bg">
        <div class="container stat-strip">
          <div v-for="stat in stats" :key="stat.label" class="stat-item">
            <strong>
              {{ stat.value }}<small>{{ stat.unit }}</small>
            </strong>
            <span>{{ stat.label }}</span>
          </div>
        </div>
      </div>
    </router-link>

    <section class="section service-section" id="services">
      <div class="container">
        <div class="center-title">
          <span>GPS LOCATOR ONE-STOP SERVICE</span>
          <h2>GPS定位器一站式服务</h2>
        </div>
        <div class="service-tabs">
          <button
            v-for="(item, index) in serviceTabs"
            :key="item.title"
            type="button"
            :class="{ active: index === activeServiceIndex }"
            @click="activeServiceIndex = index"
          >
            <img :src="item.icon" :alt="item.title">
            <span>{{ item.title }}</span>
          </button>
        </div>
        <div class="service-detail">
          <div class="product-family">
            <img :src="activeService.image" :alt="activeService.title">
          </div>
          <div class="service-copy">
            <h3>{{ activeService.heading }}</h3>
            <ul>
              <li v-for="point in activeService.points" :key="point.title">
                <img :src="successIcon" alt="">
                <span class="point-title">{{ point.title }}</span>
                <span class="point-desc">{{ point.desc }}</span>
              </li>
            </ul>
            <router-link class="btn primary small" :to="activeService.actionPath">立即咨询</router-link>
          </div>
        </div>
      </div>
    </section>

    <section class="section solutions-section" id="solutions">
      <div class="container">
        <div class="center-title">
          <span>GPS LOCATOR SOLUTION</span>
          <h2>GPS定位器解决方案</h2>
        </div>
        <div class="solution-grid">
          <router-link
            v-for="item in solutions"
            :key="item.title"
            tag="article"
            :to="item.path"
            class="solution-card"
          >
            <img class="solution-icon" :src="item.icon" :alt="item.title">
            <div>
              <h3>{{ item.title }}</h3>
              <p>{{ item.desc }}</p>
              <span class="card-link">了解更多 →</span>
            </div>
          </router-link>
        </div>
      </div>
    </section>

    <section class="section product-section" id="products">
      <div class="container">
        <div class="center-title">
          <span>PRODUCT CENTER</span>
          <h2>产品中心</h2>
        </div>
      </div>
      <div class="product-carousel" aria-label="产品中心轮播">
        <div class="product-row">
        <router-link
          v-for="(product, index) in productLoop"
          :key="`${product.name}-${index}`"
          tag="article"
          to="/cases"
          class="product-card"
        >
          <div class="product-visual">
            <img :src="product.image" :alt="product.name">
          </div>
          <h3>{{ product.name }}</h3>
          <p>{{ product.desc }}</p>
          <span class="card-link">查看详情 →</span>
        </router-link>
        </div>
      </div>
      <router-link class="btn primary more-products" to="/cases">更多产品</router-link>
    </section>

    <section class="section app-section">
      <div class="container">
        <router-link tag="div" class="app-feature" to="/news#intro">
          <h2>APP定制开发功能展示</h2>
          <img :src="app1Image" alt="APP定制开发功能展示">
        </router-link>
        <router-link tag="div" class="app-feature" to="/news#intro">
          <h2>个性化UI案例展示</h2>
          <img :src="app2Image" alt="个性化UI案例展示">
        </router-link>
      </div>
    </section>

    <section ref="dataSection" class="data-section">
      <div class="data-sticky">
        <div class="data-title">
          <h2>数据卓越&nbsp;&nbsp;领跑行业新高度</h2>
          <p>Explosive GPS locator product</p>
        </div>
        <div class="data-visual" aria-live="polite">
          <figure
            v-for="(slide, index) in dataSlides"
            :key="slide.alt"
            :class="{ active: activeDataIndex === index }"
            :style="getDataSlideStyle(index)"
          >
            <img :src="slide.image" :alt="slide.alt" @load="updateDataSection">
          </figure>
        </div>
      </div>
    </section>

    <section class="section clients-section">
      <div class="container">
        <div class="center-title">
          <span>GPS LOCATOR ONE-STOP SERVICE</span>
          <h2>来自各行各业客户的肯定与信任</h2>
        </div>
        <div class="client-marquee" aria-label="合作品牌轮播">
          <div
            v-for="(row, rowIndex) in brandRows"
            :key="rowIndex"
            class="client-row"
            :class="{ reverse: rowIndex === 1 }"
          >
            <div class="client-track">
              <span
                v-for="(brand, index) in row.concat(row)"
                :key="`${rowIndex}-${index}`"
                class="client-logo"
              >
                <img :src="brand" alt="">
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getStoredLanguage } from '../i18n/localLanguage'

export default {
  name: 'HomeView',
  data() {
    return {
      currentLanguage: getStoredLanguage(),
      activeHeroIndex: 0,
      heroTimer: null,
      heroProgressKey: 0,
      heroArrowLeft: require('@/assets/image/left.png'),
      heroArrowRight: require('@/assets/image/right.png'),
      successIcon: require('@/assets/image/success.png'),
      activeServiceIndex: 0,
      activeDataIndex: 0,
      dataTransitionProgress: 0,
      dataSlides: [
        { image: require('@/assets/image/data1.png'), alt: '实时访问数据' },
        { image: require('@/assets/image/data2.png'), alt: '强大的数据处理能力' }
      ],
      heroSlides: [
        {
          image: require('@/assets/image/banner1.png'),
          kicker: '4G GPS全球通系列',
          title: '多应用场景GPS成品供应',
          subtitle: '多国语言  |  多种地图  |  高能续航  |  超长记录',
          tab: '多应用场景GPS成品供应',
          detailPath: '/services#vehicle'
        },
        {
          image: require('@/assets/image/banner2.png'),
          kicker: 'GPS全系列定位产品研发',
          title: 'GPS定位器产品软硬件开发',
          subtitle: 'GPS硬件开发  |  嵌入式软件开发  |  后台管理系统开发  |  硬件开模生产',
          tab: 'GPS定位产品软硬件开发',
          detailPath: '/news#intro'
        },
        {
          image: require('@/assets/image/banner3.png'),
          kicker: '软件平台服务器定制开发',
          title: 'GPS定位器服务器/APP软件开发',
          subtitle: '源码开发APP  |  小程序  |  H5  |  网站  |  后台管理系统  |  物联网工程  |  安卓开发  |  IOS开发',
          tab: '服务器/APP软件开发',
          detailPath: '/news#intro'
        },
        {
          image: require('@/assets/image/banner4.png'),
          kicker: '从设计到量产全程赋能',
          title: 'GPS定位器 OEM/ODM 全周期服务',
          subtitle: 'PCB Layout设计布线  |  PCB快速打样  |  BOM物料配单采购  |  SMT贴片  |  DIP插件  |  PCBA主板产品测试',
          tab: '支持OEM/ODM',
          detailPath: '/news#intro'
        }
      ],
      stats: [
        { value: '1000', unit: '万+', label: '企业服务客户' },
        { value: '1500', unit: '万+', label: '平台监控设备' },
        { value: '800', unit: '+', label: '独立研发创新型产品' },
        { value: '160', unit: '+', label: '拥有独立知识产权' }
      ],
      serviceTabs: [
        {
          title: '成品供应',
          heading: '多应用场景GPS成品供应',
          icon: require('@/assets/image/info1.png'),
          image: require('@/assets/image/info1_bg.png'),
          actionPath: '/contact',
          points: [
            { title: '定制化GPS解决方案', desc: '根据客户的实际需求，为其设计出最优的GPS设备解决方案' },
            { title: '全方位技术支持与售后服务', desc: '我们承诺快速响应客户的反馈和需求。确保客户满意度' },
            { title: '一站式采购与交付服务', desc: '客户可以根据实际需求，选择批量采购或按需订购的方式' }
          ]
        },
        {
          title: '软硬件开发',
          heading: 'GPS定位器硬件与嵌入式软件开发',
          icon: require('@/assets/image/info2.png'),
          image: require('@/assets/image/info2_bg.png'),
          actionPath: '/news#intro',
          points: [
            { title: 'GPS硬件开发', desc: 'GPS硬件原理图、电路图设计，产品外观ID设计私模定制服务，PCBA集成定制服务，提供开发、测试、生产及售后全流程一站式服务' },
            { title: 'GPS嵌入式软件开发', desc: 'GPS定位器功能定制开发，支持多语言编程，支持私有化通讯协议定制，定制AT指令、短信指令，驱动优化，算法优化。' }
          ]
        },
        {
          title: '服务器/APP开发',
          heading: '服务器/APP开发',
          icon: require('@/assets/image/info3.png'),
          image: require('@/assets/image/info3_bg.png'),
          actionPath: '/news#intro',
          points: [
            { title: 'App应用开发', desc: 'App应用开发与，个性化定制\n安卓系统 / IOS系统 / H5页面 / 小程序 / 鸿蒙系统等' },
            { title: '后端网页开发及服务器部署', desc: '开发环境搭建、前端后端开发、API开发、数据库管理、安全性保障、性能优化、服务器配置与部署、移动设备适配\n海内外服务器部署 / 运维管理平台开发 / 支持厂家协议对接 / 定制' }
          ]
        },
        {
          title: '支持OEM/ODM',
          heading: 'PCBA一站式生产及OEM/ODM定制',
          icon: require('@/assets/image/info4.png'),
          image: require('@/assets/image/info4_bg.png'),
          actionPath: '/news#intro',
          points: [
            { title: 'PCBA一站式生产', desc: 'PCB Layout设计布线，PCB快速打样，BOM物料配单采购，SMT贴片、DIP插件，PCBA主板产品测试，整机产品组装、测试、包装及质检等。' },
            { title: 'OEM/ODM定制', desc: '硬件定制、软件定制、技术支持与培训、生产与质量控制（针对OEM）以及整体方案设计、生产与供应链管理' }
          ]
        }
      ],
      solutions: [
        {
          icon: require('@/assets/image/plan1.png'),
          title: '车辆位置追踪管理',
          path: '/services#vehicle',
          desc: '面向车辆位置管理需求，千讯云创基于车载GPS（包括有线GPS+无线GPS）的解决方案，实现车辆的跟踪定位、异常告警、远程控制及调度、里程统计等功能。'
        },
        {
          icon: require('@/assets/image/plan2.png'),
          title: '金融风控解决方案',
          path: '/services#finance',
          desc: '千讯云创，为您提供行之有效的风控智能硬件方案，主要从贷（租）后技术创新的维度上通过GPS/北斗智能定位终端监控管理，助力汽车金融行业风控水平的提升。'
        },
        {
          icon: require('@/assets/image/plan3.png'),
          title: '智慧人员定位解决方案',
          path: '/services#people',
          desc: '专门为智慧人员打造的定制化IoT解决方案，全方位守护孩子与老人的安全，实时追踪老人或小孩的位置，设定特定的安全区域。'
        },
        {
          icon: require('@/assets/image/plan4.png'),
          title: '畜牧、宠物定位解决方案',
          path: '/services#livestock',
          desc: '千讯云创，专注于提供畜牧与宠物定位器的综合解决方案，利用先进的GPS定位技术和物联网平台，实现牲畜与宠物的实时追踪、健康监测与智能管理。'
        }
      ],
      caseLogos: ['迅驰捷运', '一嗨ehi', '乐昌客运', '恒大集团', '中农地质研究院'],
      products: [
        { name: 'GF08 微型定位器', desc: '极致超小 超长续航', image: require('@/assets/image/product1.png') },
        { name: 'GF11 超小型定位器', desc: '比硬币还小，屏蔽便携', image: require('@/assets/image/product2.png') },
        { name: 'GF22 GPS定位器', desc: '升级创新，磁吸安装', image: require('@/assets/image/product3.png'), featured: true },
        { name: 'Q19太阳能畜牧智能定位终端', desc: '牛马羊通用，4G+2G 信号无盲区', image: require('@/assets/image/product4.png') },
        { name: 'P6 4G全球定位器', desc: '全球频段精准定位', image: require('@/assets/image/product5.png') },
        { name: 'PG09 车载GPS定位器', desc: '免充电持续定位', image: require('@/assets/image/product6.png') },
        { name: 'PG07 车载GPS定位器', desc: '免充电持续定位', image: require('@/assets/image/product7.png') },
        { name: 'M8宠物定位器', desc: '炫彩灯光 安心陪伴', image: require('@/assets/image/product8.png') },
        { name: 'M9 人员GPS定位器', desc: '精准定位 安心陪伴', image: require('@/assets/image/product9.png') },
        { name: 'M10 宠物定位器', desc: '精致小巧 悄悄守护', image: require('@/assets/image/product10.png') }
      ],
      brands: [
        require('@/assets/image/brand1.png'),
        require('@/assets/image/brand2.png'),
        require('@/assets/image/brand3.png'),
        require('@/assets/image/brand4.png'),
        require('@/assets/image/brand5.png'),
        require('@/assets/image/brand6.png'),
        require('@/assets/image/brand7.png'),
        require('@/assets/image/brand8.png'),
        require('@/assets/image/brand9.png'),
        require('@/assets/image/brand10.png'),
        require('@/assets/image/brand11.png'),
        require('@/assets/image/brand12.png'),
        require('@/assets/image/brand13.png'),
        require('@/assets/image/brand14.png'),
        require('@/assets/image/brand15.png'),
        require('@/assets/image/brand16.png'),
        require('@/assets/image/brand17.png'),
        require('@/assets/image/brand18.png'),
        require('@/assets/image/brand19.png'),
        require('@/assets/image/brand20.png'),
        require('@/assets/image/brand21.png'),
        require('@/assets/image/brand22.png'),
        require('@/assets/image/brand23.png'),
        require('@/assets/image/brand24.png'),
        require('@/assets/image/brand25.png'),
        require('@/assets/image/brand26.png'),
        require('@/assets/image/brand27.png'),
        require('@/assets/image/brand28.png'),
        require('@/assets/image/brand29.png'),
        require('@/assets/image/brand30.png'),
        require('@/assets/image/brand31.png'),
        require('@/assets/image/brand32.png'),
        require('@/assets/image/brand33.png'),
        require('@/assets/image/brand34.png'),
        require('@/assets/image/brand35.png'),
        require('@/assets/image/brand36.png'),
        require('@/assets/image/brand37.png'),
        require('@/assets/image/brand38.png'),
        require('@/assets/image/brand39.png'),
        require('@/assets/image/brand40.png'),
        require('@/assets/image/brand41.png'),
        require('@/assets/image/brand42.png')
      ]
    }
  },
  computed: {
    isEnglish() {
      return this.currentLanguage === 'en'
    },
    app1Image() {
      return this.isEnglish ? require('@/assets/image/app1_en.png') : require('@/assets/image/app1.png')
    },
    app2Image() {
      return this.isEnglish ? require('@/assets/image/app2_en.png') : require('@/assets/image/app2.png')
    },
    activeHero() {
      return this.heroSlides[this.activeHeroIndex]
    },
    activeService() {
      return this.serviceTabs[this.activeServiceIndex]
    },
    productLoop() {
      return this.products.concat(this.products)
    },
    brandRows() {
      return [
        this.brands.slice(0, 14),
        this.brands.slice(14, 28),
        this.brands.slice(28, 42)
      ]
    }
  },
  mounted() {
    this.startHeroTimer()
    this.updateDataSection()
    window.addEventListener('site-language-change', this.syncLanguage)
    window.addEventListener('scroll', this.handleDataScroll, { passive: true })
    window.addEventListener('resize', this.updateDataSection)
  },
  beforeDestroy() {
    this.stopHeroTimer()
    window.removeEventListener('site-language-change', this.syncLanguage)
    window.removeEventListener('scroll', this.handleDataScroll)
    window.removeEventListener('resize', this.updateDataSection)
  },
  methods: {
    syncLanguage(event) {
      this.currentLanguage = event.detail || getStoredLanguage()
    },
    startHeroTimer() {
      this.stopHeroTimer()
      this.heroProgressKey += 1
      this.heroTimer = window.setInterval(() => {
        this.setHeroIndex((this.activeHeroIndex + 1) % this.heroSlides.length)
      }, 5000)
    },
    stopHeroTimer() {
      if (this.heroTimer) {
        window.clearInterval(this.heroTimer)
        this.heroTimer = null
      }
    },
    setHeroIndex(index) {
      this.activeHeroIndex = index
      this.heroProgressKey += 1
    },
    goToHero(index) {
      this.setHeroIndex(index)
      this.startHeroTimer()
    },
    prevHero() {
      const index = (this.activeHeroIndex - 1 + this.heroSlides.length) % this.heroSlides.length
      this.goToHero(index)
    },
    nextHero() {
      const index = (this.activeHeroIndex + 1) % this.heroSlides.length
      this.goToHero(index)
    },
    updateDataSection() {
      this.$nextTick(() => {
        this.handleDataScroll()
      })
    },
    handleDataScroll() {
      const section = this.$refs.dataSection
      if (!section) return

      const visual = section.querySelector('.data-visual')
      if (!visual) return

      const rect = visual.getBoundingClientRect()
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight
      const headerOffset = window.matchMedia('(max-width: 860px)').matches ? 0 : 60
      const availableHeight = viewportHeight - headerOffset
      const fullyVisibleTop = rect.height < availableHeight
        ? viewportHeight - rect.height
        : headerOffset
      const transitionEndTop = rect.height < availableHeight
        ? headerOffset + Math.min(120, availableHeight * 0.16)
        : headerOffset - rect.height * 0.28
      const transitionDistance = Math.max(fullyVisibleTop - transitionEndTop, 1)
      const progress = Math.min(Math.max((fullyVisibleTop - rect.top) / transitionDistance, 0), 1)

      this.dataTransitionProgress = progress
      this.activeDataIndex = progress >= 0.5 ? 1 : 0
    },
    getDataSlideStyle(index) {
      const progress = this.dataTransitionProgress
      const opacity = index === 0 ? 1 - progress : progress
      const offset = index === 0 ? -18 * progress : 22 * (1 - progress)
      const scale = index === 0 ? 1 - progress * 0.018 : 0.982 + progress * 0.018

      return {
        opacity,
        transform: `translateY(${offset}px) scale(${scale})`
      }
    }
  }
}
</script>
